import { render, staticRenderFns } from "./AddDefinitionChildren.vue?vue&type=template&id=08174e42&scoped=true&"
import script from "./AddDefinitionChildren.vue?vue&type=script&lang=js&"
export * from "./AddDefinitionChildren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08174e42",
  null
  
)

export default component.exports